import React, { Component, Fragment } from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogTitle,
    DialogContent,
    FormControl,
    withMobileDialog,
    TextField
} from "@material-ui/core";
import { Close } from "@material-ui/icons";
import { MuiThemeProvider } from "@material-ui/core/styles";
import _ from "lodash";
import modal from "../modal.scss";
import styles from "./styles.scss";
import cx from "classnames";
import customMaterialUi from "../../../materialUITheme";
import { bool, func, oneOfType, string, shape } from "prop-types";


class CreateFolder extends Component {

    state = {
        anchorEl: null,
        name: "",
        errorMsg: "",
        open: false
    };

    handleSubmitForm = (event) => {
        event.preventDefault();
        const {
            addFolderSaga,
            editingFolder
        } = this.props;
        if (editingFolder.loading) {
            return;
        }
        addFolderSaga(editingFolder);
        this.closeMenu();
    };

    handleSubmitAndNext = () => {
        const { addFolderAndAdvertiserSaga, editingFolder } = this.props;
        addFolderAndAdvertiserSaga(editingFolder);
        this.closeMenu();
    };

    onChangeInput = (event) => {
        const { editingFolder, editFolder } = this.props;
        editFolder({
            ...editingFolder,
            folder_name: event.target.value,
            errMsg: ""
        });
        this.setState({
            name: event.target.value,
            errorMsg: ""
        });
    };

    closeMenu = () => {
        this.setState({ anchorEl: null });
    };

    render() {
        const { fullScreen, editingFolder = {}, modalOpen, onClose } = this.props;
        const { errorMsg } = this.state;
        const { folder_name = "", currentFolderId } = editingFolder;
        const errMsg = _.get(editingFolder, "errMsg", "");
        const inAdvertiserTab = _.isEqual(modalOpen, "inAdvertiserTab");
        const loading = _.get(editingFolder, "loading", false);
        return (
            <Dialog
                open={!!modalOpen}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        onClose(reason);
                    }
                }}
                disableEscapeKeyDown
                className={cx(modal["modal"], modal["modal-create-folder"])}
                PaperProps={{ className: cx(modal["confirm-modal"]) }}
                fullScreen={fullScreen}
            >
                <form onSubmit={this.handleSubmitForm}>
                    <DialogTitle className={cx(modal["modal-heading"])}>
                        {
                            currentFolderId ? "Edit Folder" : "Create New Folder"
                        }
                        <Button
                            className={cx(modal["modal__close"])}
                            onClick={onClose}
                        >
                            <Close/>
                        </Button>
                    </DialogTitle>
                    <DialogContent className={cx(modal["modal-body"])}>
                        <FormControl fullWidth>
                            <MuiThemeProvider theme={customMaterialUi}>
                                <TextField
                                    label="Folder Name"
                                    value={folder_name}
                                    onChange={this.onChangeInput}
                                    error={!!errMsg}
                                    helperText={errMsg}
                                    autoFocus
                                />
                            </MuiThemeProvider>
                            <p className={cx(modal.error)}>{errorMsg}</p>
                        </FormControl>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={onClose}
                            color="secondary"
                            className={cx(styles["btn-cancel"])}
                            data-veritone-element="button-cancel-create-folder-modal"
                        >
                            Cancel
                        </Button>
                        {
                            currentFolderId ? (
                                <Button
                                    onClick={this.handleSubmitForm}
                                    variant="contained"
                                    color="primary"
                                    type="submit"
                                    className={cx(styles["btn-done"])}
                                    disabled={loading}
                                    data-veritone-element="button-save-create-folder-modal"
                                >
                                    Save
                                </Button>
                            ) : (
                                !inAdvertiserTab ?
                                    <Fragment>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            type="button"
                                            className={cx(modal["btn-primary"], styles["btn-done"])}
                                            onClick={this.handleSubmitForm}
                                            data-veritone-element="button-create-folder-modal"
                                        >
                                            Create
                                        </Button>
                                    </Fragment>
                                    :
                                    <Fragment>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            type="button"
                                            className={cx(modal["btn-primary"], styles["btn-done"])}
                                            onClick={this.handleSubmitForm}
                                            disabled={loading}
                                            data-veritone-element="button-create-folder-modal"
                                        >
                                            Create
                                        </Button>
                                    </Fragment>
                            )
                        }

                    </DialogActions>
                </form>
            </Dialog>
        );
    }
}

CreateFolder.propTypes = {
    addFolderSaga: func.isRequired,
    addFolderAndAdvertiserSaga: func.isRequired,
    editFolder: func.isRequired,
    fullScreen: bool,
    editingFolder: shape({
        folder_id: string.isRequired
    }),
    modalOpen: oneOfType([string, bool]),
    onClose: func.isRequired
};

CreateFolder.defaultProps = {
    fullScreen: true
};

export default withMobileDialog()(CreateFolder);
